import { useMemo, type ReactElement, type ReactNode } from 'react';

import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router';

import { getActiveCompanyId } from './active-company-store';
import { createApiClient } from './api';
import { ApiContext } from './api-context';

interface Props {
  children: ReactNode;
}

export function ApiProvider({ children }: Props): ReactElement {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();

  const client = useMemo(() => {
    return createApiClient(
      () => getAccessTokenSilently(),
      () => {
        // 401 → redirigir a login preservando la URL actual
        const currentPath = window.location.pathname + window.location.search;
        void loginWithRedirect({ appState: { returnTo: currentPath } });
        void navigate('/login', { replace: true });
      },
      getActiveCompanyId,
    );
  }, [getAccessTokenSilently, loginWithRedirect, navigate]);

  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}
